<template>
  <v-card>
    <v-card-title>
      {{ $t('admin_user.add_gym_pass_title') }}
    </v-card-title>
    <v-card-text>
      <div class="upload-file-form">
        <v-select outlined
                  :label="''"
                  :items="subscriptionTypeOptions"
                  v-model="value"></v-select>
      </div>
    </v-card-text>
    <v-card-actions class="text-right">
      <v-spacer></v-spacer>
      <v-btn text
             @click="$emit('submit', undefined)">
        {{ $t('cancel') }}
      </v-btn>
      <v-btn text
             color="primary"
             :disabled="!value"
             @click="$emit('submit', value)">
        {{ $t('ok') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>

import {computed, onMounted, ref} from "@vue/composition-api";

export default {
  name: 'AdminAddGymPassDialog',
  props: {},
  setup(props, {root}) {
    const value = ref(null);

    const subscriptionTypes = ref([]);
    const subscriptionTypeOptions = computed(() => {
      return subscriptionTypes.value.map((t) => {
        return {text: t.name, value: t.id};
      })
    })
    const getSubscriptionTypes = function () {
      root.$callAPI('aafb/gym_subscription/types/', {}, function (response) {
        subscriptionTypes.value = response.body.subscription_types;
      });
    }
    onMounted(() => {
      getSubscriptionTypes()
    })

    return {
      value,
      subscriptionTypeOptions,
    }
  }
}
</script>
